export const FORM_CLAIM_CREATE = ({
  onEnter,
  provinceOptions,
  districtOptions,
  subDistrictOptions,
  addressOptions,
  watch,
  showStoreField,
}) => {
  const span = 12;
  const hasOldAddress = (addressOptions || []).length > 0;

  const SHOW_RADIO = [
    ...(!['FOCUS', 'STORE'].includes(showStoreField)
      ? [
          {
            name: 'isCreateNewAddress',
            label: 'ที่อยู่เดิม',
            type: 'RADIO',
            span: 24,
            defaultValue: hasOldAddress ? 'false' : 'true',
            properties: {
              options: [
                { label: 'ที่อยู่เดิม', value: 'false', disabled: !hasOldAddress },
                { label: 'เพิ่มที่อยู่ใหม่', value: 'true' },
              ],
            },
            rules: {
              required: true,
            },
          },
        ]
      : []),
  ];

  return [
    {
      name: 'telephone',
      label: 'หมายเลขโทรศัพท์',
      type: 'INPUT_PHONE',
      placeholder: 'กรุณากรอกหมายเลขโทรศัพท์',
      onEnter,
      span,
      maxLength: 10,
      rules: {
        required: true,
        pattern: /^[0-9]*$/,
      },
    },
    {
      name: 'fullName',
      label: 'ชื่อ-นามสกุล',
      type: 'INPUT',
      placeholder: 'กรุณากรอกชื่อ-นามสกุล',
      span,
      rules: {
        required: true,
      },
    },
    ...SHOW_RADIO,
    ...(!['FOCUS', 'STORE'].includes(showStoreField)
      ? [
          {
            name: 'customerAddressId',
            label: 'เลือกที่อยู่',
            type: 'DROPDOWN',
            placeholder: 'กรุณาเลือก',
            disabled: !hasOldAddress || watch('isCreateNewAddress') === 'true',
            properties: {
              options: addressOptions || [],
            },
            rules: {
              required: hasOldAddress && watch('isCreateNewAddress') !== 'true',
            },
            span: 24,
          },
        ]
      : []),
    ...(!['FOCUS', 'STORE'].includes(showStoreField)
      ? [
          {
            name: 'info',
            label: hasOldAddress
              ? 'หากต้องการเพิ่มที่อยู่ใหม่กรอกรหัสไปรษณีย์แล้วกด Enter'
              : 'กรอกรหัสไปรษณีย์ของที่อยู่ใหม่แล้วกด Enter',
            type: 'TEXT',
            span: 24,
            style: {
              textDecoration: 'underline',
            },
          },
          {
            name: 'zipCode',
            label: 'รหัสไปรษณีย์',
            type: 'INPUT',
            placeholder: 'กรุณากรอกรหัสไปรษณีย์',
            span,
            onEnter,
            rules: {
              required: true,
            },
          },
          {
            name: 'provinceId',
            label: 'จังหวัด',
            type: 'DROPDOWN',
            placeholder: 'กรุณาเลือกจังหวัด',
            properties: {
              options: provinceOptions || [],
              getOptionLabel: (option) => option.label || option.provinceLabel,
              getOptionValue: (option) => option.value || option.provinceId,
            },
            span,
            rules: {
              required: true,
            },
          },
          {
            name: 'districtId',
            label: 'เขต/อำเภอ',
            type: 'DROPDOWN',
            placeholder: 'กรุณาเลือกเขต/อำเภอ',
            properties: {
              options: districtOptions || [],
              getOptionLabel: (option) => option.label || option.districtLabel,
              getOptionValue: (option) => option.value || option.districtId,
            },
            span,
            rules: {
              required: true,
            },
          },
          {
            name: 'subDistrictId',
            label: 'แขวง/ตำบล',
            type: 'DROPDOWN',
            placeholder: 'กรุณาเลือกแขวง/ตำบล',
            properties: {
              options: subDistrictOptions || [],
              getOptionLabel: (option) => option.label || option.subDistrictLabel,
              getOptionValue: (option) => option.value || option.subDistrictId,
            },
            span,
            rules: {
              required: true,
            },
          },
          {
            name: 'other',
            label: 'ที่อยู่เพิ่มเติม (บ้านเลขที่/ซอย/ถนน)',
            type: 'INPUT',
            placeholder: 'เช่น บ้านเลขที่ หมู่ ซอย ถนน หรือจุดสังเกตของบ้าน',
            span: 24,
            maxLength: 60,
            rules: {
              required: true,
              maxLength: { value: 60, message: 'ระบุไม่เกิน 60 ตัวอักษร' },
              validate: (value) =>
                !!String(value || '').trim() ||
                'กรุณาระบุที่อยู่เพิ่มเติม เช่น บ้านเลขที่ ซอย หรือถนน',
            },
          },
        ]
      : []),
  ];
};

export const FORM_CLAIM_DATA = ({
  productOptions,
  breakdownOptions,
  channelClaim,
  storeTypeChannelOptions,
  showStoreField,
}) => {
  const span = 24;
  const accept = [`image/jpeg`, 'image/png', 'image/jpg', 'image/bmp', 'image/tiff'];

  const SHOW_STORE = [
    {
      name: 'storeId',
      label: 'ร้านค้า',
      type: 'DROPDOWN',
      placeholder: '',
      properties: {
        options: storeTypeChannelOptions || [],
      },
      rules: {
        required: true,
      },
      span,
    },
  ];

  const SHOW_DATE_SERVICE = [
    {
      name: 'bookingDate',
      label: 'วันที่บริการ',
      type: 'DATE_PICKER',
      rules: {
        required: true,
      },
      span,
    },
  ];

  return [
    {
      name: 'warrantyId',
      label: 'เลือกสินค้าที่ต้องการเคลม',
      type: 'DROPDOWN',
      properties: {
        options: productOptions || [],
      },
      span,
      style: {
        height: 'auto',
        maxHeight: '200px',
        width: '100%',
        overflowY: 'auto',
      },
      rules: {
        required: true,
      },
    },
    {
      name: 'breakdownId',
      label: 'อาการเสีย',
      type: 'DROPDOWN',
      properties: {
        options: breakdownOptions || [],
      },
      rules: {
        required: true,
      },
      span,
    },
    {
      name: 'detail1',
      label: 'รายละเอียด',
      type: 'INPUT',
      placeholder: '',
      span,
    },
    {
      name: 'noDeductWarranty',
      label: 'ไม่ตัดประกัน (ต้องรออนุมัติก่อนส่ง CS)',
      type: 'CHECKBOX',
      properties: {
        options: [{ label: '', value: 'Y' }],
      },
      span,
    },
    {
      name: 'channelClaimId',
      label: 'ช่องทางการเคลม',
      type: 'DROPDOWN',
      properties: {
        options: channelClaim || [],
      },
      rules: {
        required: true,
      },
      span,
    },
    ...(['STORE', 'FOCUS'].includes(showStoreField) ? SHOW_STORE : []),
    ...(showStoreField === 'FOCUS' ? SHOW_DATE_SERVICE : []),
    {
      name: 'claimImage',
      label: 'รูปภาพสินค้า (.png, .jpg, .jpeg, .bmp, .gif)',
      type: 'UPLOAD',
      listType: 'picture-card',
      accept: accept.join(','),
      span,
      rules: {
        required: true,
      },
      maxCount: 1,
    },
    {
      name: 'receiptImage',
      label: 'รูปภาพสลิปค่าขนส่ง (.png, .jpg, .jpeg, .bmp)',
      type: 'UPLOAD',
      listType: 'picture-card',
      accept: accept.join(','),
      span,
      maxCount: 1,
    },
  ];
};
